import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	PartnerOneDayShortModel,
	PartnerOneDayModel,
	STATUS_PARTNER,
	PartnerOneDayUpdateModel,
	AllDocumentPartner,
} from 'Pages/partner'
import { Id } from 'Src/types/aliases'
import { FileWithPreview } from 'LibNeo'

export const partnersApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<PartnerOneDayShortModel>>(urls.partner.index, {
			params,
		})
		return res.data
	},
	getOne: async (id: Id) => {
		const res = await axiosDS().get<PartnerOneDayModel>(`${urls.partner.index}/${id}`)
		return res.data
	},
	getDocuments: async (id: Id) => {
		const res = await axiosDS().get<AllDocumentPartner>(
			`${urls.partner.index}/${id}/document/doc_list`
		)
		return res.data
	},
	setStatus: async (id: Id, status: STATUS_PARTNER) => {
		const res = await axiosDS().patch<PartnerOneDayModel>(
			`${urls.partner.index}/${id}/set_status/${status}`
		)
		return res.data
	},
	updateOne: async (id: Id, data: PartnerOneDayUpdateModel) => {
		const res = await axiosDS().patch<PartnerOneDayModel>(`${urls.partner.index}/${id}`, { data })
		return res.data
	},
	updateOneDay: async (id: Id, data: PartnerOneDayUpdateModel) => {
		const res = await axiosDS().patch<PartnerOneDayModel>(
			`${urls.partner.index}/${id}/one_day_update`,
			{
				data,
			}
		)
		return res.data
	},
	postSvetoforFile: async (file: FileWithPreview) => {
		const data = new FormData()
		data.append('[data][file]', file as unknown as File)
		const res = await axiosDS().post(`${urls.partner.index}/svetofor_check_report`, data)
		return res.data
	},
}
